import {sx} from './sx'
import {TableHead} from "@mui/material";
import {FC, ReactNode} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps{
    children:ReactNode,
    sx?:SxType,
}
const TheadCustom:FC<IProps> = ({

                         children,
                         sx: sxProps,
                     }) => {
    return (
        <TableHead
            sx={sxProps ?? sx}
        >
            {children}
        </TableHead>
    );
};

export default TheadCustom;